interface CVSectionProps {
  title: string;
  description: string;
}

function CVSection({ title, description }: CVSectionProps): JSX.Element {
  return (
    <div className="border-l-4 border-blue-500 pl-4">
      <h3 className="text-lg font-semibold text-gray-800 mb-2">
        {title}
      </h3>
      <p className="text-gray-600">
        {description}
      </p>
    </div>
  );
}

export default CVSection;